import { getExtFile } from '../../libs/get-ext-file';

const generateDPR = (data = {}) => {
  if (!data['1x']) {
    console.error('Normalize data for picture error: not 1x');
    return [];
  }

  const is2x = !!data['2x'];

  const getSrc = (x1, x2) => {
    if (!x1) {
      return '';
    }

    if (is2x) {
      return x1 + ' 1x, ' + x2 + ' 2x';
    } else {
      return x1 + ' 1x';
    }
  };

  const webp = {
    srcSet: getSrc(data['1x'][1], is2x && data['2x'][1]),
    type: 'image/webp',
  };

  const def = {
    srcSet: getSrc(data['1x'][0], is2x && data['2x'][0]),
    type: 'image/' + getExtFile(data['1x'][0]),
  };

  // порядок важен, иначе webp не будет подгружаться
  return [webp, def];
};

const generatePoints = (data = {}) => {
  const keys = Object.keys(data).filter((item) => !item.includes('x'));

  return keys.reduce((acc, key) => {
    const links = data[key];

    if (!links) {
      return;
    }

    links.forEach((link) => {
      const element = {
        media: `(max-width: ${key}px)`,
        srcSet: link,
        type: 'image/' + getExtFile(link),
      };

      acc.push(element);
    });

    return acc;
  }, []);
};

// возвращает не webp и тот где есть 1x, для src убираем 2x
const getDefaultImage = (pictureData) => {
  const item = pictureData.find((item) => !item.type.includes('webp') && item.srcSet.includes('1x'));

  if (!item) {
    return {};
  }

  return {
    ...item,
    srcSet: item.srcSet.split(' ')[0],
  };
};

export const normalizePictureData = (data) => {
  const pictureData = [...generatePoints(data), ...generateDPR(data)];
  const defaultImage = getDefaultImage(pictureData);

  return { pictureData, defaultImage };
};
